<template>
  <div id="software-database" style="" >
    <h3 class="titles" style="font-family: 'Arial';margin-top: 10px;">Software & Database</h3>
    <div style="border: 3px solid #CCCCCC; width: 300px"></div>

    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;"
          :src="url_spiral"
          :preview-src-list="srcList_spiral">
        </el-image>
        <!--        <img src="../assets/cancersrt.png" alt="" width="100%" style="">-->
      </div>
      <div class="card-right">
        <p>
          <span class="title-span" style="font-family: 'Arial';">SPIRAL</span>
          <br/>
          <span style="text-align: left">
            <b style="font-family: 'Arial'; font-size: 16px">
              
            </b>
          </span>
        </p>
        <p >
          <span style="text-align: left; font-family: 'Arial';word-spacing: 0;letter-spacing: 0;">
        SPIRAL:method developed for integrating and aligning spatially resolved transcriptomics data across different experiments.conditions,and technologies. <a href="https://github.com/XiangyuLi-Lab/SPIRAL" target="_blank"> Click here to visit</a>.
          </span>
        </p>
      </div>
    </div>

    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;"
          :src="url_cancersrt"
          :preview-src-list="srcList_cancersrt">
        </el-image>
<!--        <img src="../assets/cancersrt.png" alt="" width="100%" style="">-->
      </div>
      <div class="card-right">
        <p>
          <span class="title-span" style="font-family: 'Arial';">CancerSRT</span>
          <br/>
          <span style="text-align: left">
            <b style="font-family: 'Arial'; font-size: 16px">
              
            </b>
          </span>
        </p>
        <p >
          <span style="text-align: left; font-family: 'Arial';word-spacing: 0;letter-spacing: 0;">
            CancerSRT: A Spatially Resolved Transcriptomics Database for Human Cancers. <a href="http://cancersrt.info/" target="_blank">Click here to visit</a>.
          </span>
        </p>
      </div>
    </div>



    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;"
          :src="url_spadac"
          :preview-src-list="srcList_spadac">
        </el-image>
<!--        <img src="../assets/spadac.png" alt="" width="100%" style="object-fit:cover;max-height: 400px;object-position: center top;">-->
      </div>
      <div class="card-right">
        <p>
          <span class="title-span" style="font-family: 'Arial';">SpaDAC</span>
          <br/>
          <span style="text-align: left">
            <b style="font-family: 'Arial'; font-size: 16px">
              
            </b>
          </span>
        </p>
        <p >
          <span style="text-align: left; font-family: 'Arial';word-spacing: 0;letter-spacing: 0;">
            SpaDAC:Integrating multi-modal information to detect spatial domains of spatial transcriptomics by graph attention network. <a href="https://github.com/XiangyuLi-Lab/SpaDAC" target="_blank">Click here to visit</a>.
          </span>
        </p>
      </div>
    </div>
    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;"
          :src="url_scrl"
          :preview-src-list="srcList_scrl">
        </el-image>
<!--        <img src="../assets/scrl.png" alt="" width="100%" style="object-fit:cover;max-height: 400px;object-position: center top;">-->
      </div>
      <div class="card-right">

        <p>
          <span class="title-span" style="font-family: 'Arial';">SCRL</span>
          <br/>
          <span style="text-align: left">
            <b style="font-family: 'Arial'; font-size: 16px">
             
            </b>
          </span>
        </p>
        <p >
          <span style="text-align: left;font-family: 'Arial';word-spacing: 0;letter-spacing: 0;">
            SCRL: toolkit developed for learning  representations for scRNA-seq data based on network embedding, which reduce the noise and extract the signal by incorporating scRNA-seq data with knowledge. <a href="https://github.com/XiangyuLi-Lab/SCRL" target="_blank">Click here to visit</a>.
          </span>
        </p>
      </div>
    </div>

    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;"
          :src="url_scidrl"
          :preview-src-list="srcList_scidrl">
        </el-image>
        <!--        <img src="../assets/scrl.png" alt="" width="100%" style="object-fit:cover;max-height: 400px;object-position: center top;">-->
      </div>
      <div class="card-right">

        <p>
          <span class="title-span" style="font-family: 'Arial';">SCIDRL</span>
          <br/>
          <span style="text-align: left">
            <b style="font-family: 'Arial'; font-size: 16px">
              
            </b>
          </span>
        </p>
        <p >
          <span style="text-align: left; font-family: 'Arial';word-spacing: 0;letter-spacing: 0;">
            SCIDRL:a domain adaption-based method, to learn low-dimensional representations invariant to batch effect. This method can efficiently remove batch effect while retaining 
cell type purity.  <a href="https://github.com/XiangyuLi-Lab/SCIDRL" target="_blank">Click here to visit</a>.
          </span>
        </p>
      </div>
    </div>

    <div class="card">
      <div class="card-left">
        <el-image
          style="width: 100%; object-fit:cover;max-height: 350px;object-position: center top;"
          :src="url_jebin"
          :preview-src-list="srcList_jebin">
        </el-image>
        
      </div>
      <div class="card-right">

        <p>
          <span class="title-span" style="font-family: 'Arial';">JEBIN</span>
          <br/>
          <span style="text-align: left">
            <b style="font-family: 'Arial'; font-size: 16px">
            </b>
          </span>
        </p>
        <p >
          <span style="text-align: left; font-family: 'Arial';word-spacing: 0;letter-spacing: 0;">
            JEBIN: method developed to learn the low-dimensional consensus representation for genes by integrating multiple expression datasets.  
             <a href="https://github.com/XiangyuLi-Lab/JEBIN" target="_blank">Click here to visit</a>.
          </span>
        </p>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'Softwares',
  data () {
    return {
      url_spiral: require('../assets/SPIRAL.png'),
      srcList_spiral: [
        require('../assets/SPIRAL.png'),
        require('../assets/cancersrt.png'),
        require('../assets/spadac.png'),
        require('../assets/scrl.png'),
        require('../assets/JEBIN.png'),
        require('../assets/SCIDRL.png')
      ],
      url_cancersrt: require('../assets/cancersrt.png'),
      srcList_cancersrt: [
        require('../assets/cancersrt.png'),
        require('../assets/spadac.png'),
        require('../assets/scrl.png'),
        require('../assets/SCIDRL.png'),
        require('../assets/JEBIN.png'),
        require('../assets/SPIRAL.png')
      ],
      url_spadac: require('../assets/spadac.png'),
      srcList_spadac: [
        require('../assets/spadac.png'),
        require('../assets/scrl.png'),
        require('../assets/SCIDRL.png'),
        require('../assets/SPIRAL.png'),
        require('../assets/JEBIN.png'),
        require('../assets/cancersrt.png')
      ],
      url_scrl: require('../assets/scrl.png'),
      srcList_scrl: [
        require('../assets/scrl.png'),
        require('../assets/SCIDRL.png'),
        require('../assets/SPIRAL.png'),
        require('../assets/cancersrt.png'),
        require('../assets/JEBIN.png'),
        require('../assets/spadac.png')
      ],
      url_scidrl: require('../assets/SCIDRL.png'),
      srcList_scidrl: [
        require('../assets/SCIDRL.png'),
        require('../assets/scrl.png'),
        require('../assets/SPIRAL.png'),
        require('../assets/cancersrt.png'),
        require('../assets/JEBIN.png'),
        require('../assets/spadac.png')
      ],
      url_jebin: require('../assets/JEBIN.png'),
      srcList_jebin: [
        require('../assets/SCIDRL.png'),
        require('../assets/scrl.png'),
        require('../assets/SPIRAL.png'),
        require('../assets/cancersrt.png'),
        require('../assets/JEBIN.png'),
        require('../assets/spadac.png')
      ]
    }
  }
}
</script>

<style scoped>

a{
  text-decoration: none;
}
.titles{
  color: #005BAC;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
  font-size: 28px;
}
.card{
  display: flex;
  justify-content: space-evenly;
  margin: 50px 0 50px 0;
}
.card-left{
  width: 50%;
}
.card-right{
  flex: 1;
  margin-left: 5%;
}
p{
  font-size: 20px;
  line-height: 30px;
  text-align: justify;
}
.title-span{
  font-size: 28px;
  color: #005BAC;
}
#software-database{
  width: 1000px;
  margin: auto;
}


@media (max-width: 768px) {
  #software-database{
    width: 80%;
    margin: auto;
  }
  .card{
    display: flex;
    flex-direction: column; /* 改为纵向排布 */
    justify-content: space-evenly; /* 子项均匀分布 */
    margin: 50px 0;
  }
  span{
    text-align: center; 
    font-family: 'Arial';
    font-size: 16px;;
  }
  .titles{
    color: #005BAC;
    text-align: left;
    margin: 20px 0 0 0;
    padding: 0;
    font-size: 25px;
  }
  .card-left{
   width: 100%;
  }
  .card-right{
    flex: 1;
    margin-left: 5%;
  }
  .title-span{
    font-size: 22px;
    color: #005BAC;
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Softwares.vue